import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import UiKit from '../../../../../shared/ui/ui-kit';
import { colorsPalette } from '../../../../../shared/ui/styles/colors-palette';
import {
  LoadingStatus,
  SubmittingStatus,
} from '../../../../../shared/infrastructure/types/common/common-types';
import { useTranslation } from 'react-i18next';
import { useUILogic } from '../../../shared/providers/UILogicProvider/hooks';
import { useMask } from '../../../../../shared/ui/hooks/useMask';
import { maskingHandlers } from '../../../../../shared/infrastructure/masking-helpers/masking-handlers';
import { SmartCaptcha } from '../SmartCaptcha';

interface PhoneEnterFormProps {}

let PhoneEnterForm = function ({}: PhoneEnterFormProps): ReactElement {
  const { t } = useTranslation();
  const { authorizationUiModule } = useUILogic();
  const registerUIManager = authorizationUiModule.registerUIManager;
  const yandexCloudManager = authorizationUiModule.module.yandexCloudManager;
  const { value, onChangeMaskedValue } = useMask({
    defaultValue: registerUIManager.coreManager.phone,
    maskHandler: value => maskingHandlers.phoneNumberMask({ value }),
    onAccept: (maskedValue, unmaskedValue) => {
      registerUIManager.coreManager.setPhone(unmaskedValue);
    },
  });

  return (
    <Wrapper>
      <UiKit.form.Item.VerticalLayoutTemplate label={t('register.label.phone')}>
        <UiKit.form.Validation
          validateStatus={registerUIManager.coreManager.validator.phone.isValid ? '' : 'error'}
          message={t(registerUIManager.coreManager.validator.phone.errors[0]) as string}
          turnValidation={
            registerUIManager.coreManager.formStatus === SubmittingStatus.ERROR_SUBMITTING
          }
        >
          <UiKit.Input
            value={value}
            placeholder={'+7 912 000-00-00'}
            onChange={value => onChangeMaskedValue(value)}
          />
        </UiKit.form.Validation>
      </UiKit.form.Item.VerticalLayoutTemplate>
      <SmartCaptchaWrapper>
        <UiKit.form.Validation
          validateStatus={registerUIManager.coreManager.validator.captcha.isValid ? '' : 'error'}
          message={t(registerUIManager.coreManager.validator.captcha.errors[0]) as string}
          turnValidation={
            registerUIManager.coreManager.formStatus === SubmittingStatus.ERROR_SUBMITTING
          }
        >
          <SmartCaptcha
            onToken={token => registerUIManager.coreManager.setSmartCaptchaToken(token)}
          />
        </UiKit.form.Validation>
      </SmartCaptchaWrapper>
      {registerUIManager.coreManager.verificationErrorKey && (
        <VerificationError>
          {t(registerUIManager.coreManager.verificationErrorKey)}
        </VerificationError>
      )}
      <UiKit.Button
        loading={registerUIManager.coreManager.enterPhoneLoading === LoadingStatus.LOADING}
        disabled={yandexCloudManager.isBlocked}
        onClick={() => registerUIManager.coreManager.submitPhoneEnter()}
        customStyles={{ width: '100%' }}
        type={'primary'}
      >
        {t('register.continue.button')}
      </UiKit.Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
const SmartCaptchaWrapper = styled.div``;
const VerificationError = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${colorsPalette.dustyRed500};
  text-align: left;
`;

PhoneEnterForm = observer(PhoneEnterForm);

export { PhoneEnterForm };
